// Self-hosted font catalog. Mirrors backend/app/fonts.py — keep both lists
// in sync when adding a font. Files live at
// {API_BASE}/static/fonts/<Slug>-Regular.woff2 and <Slug>-Bold.woff2.
import { API_BASE } from "./api.js";

export const FONT_FAMILIES = [
  "Poppins",
  "Tinos",
  "Roboto",
  "Open Sans",
  "Montserrat",
  "Lato",
  "Inter",
  "Nunito",
  "Raleway",
  "Oswald",
  "Foco",
  "Foco Black",
];

export const DEFAULT_FONT_FAMILY = "Poppins";

let fontsReadyPromise = null;

// Adds @font-face rules for the whole catalog to <head> and explicitly
// requests every family/weight, once. Safe to call multiple times (returns
// the same cached promise) — e.g. on every editor mount.
//
// Canvas text (Fabric.js) doesn't wait for web fonts the way DOM text does:
// if a font-family isn't already in `document.fonts` by the time canvas
// draws, it silently falls back and never retries. Explicitly loading every
// family here means all glyphs are cached well before a user could pick one
// from the editor's dropdown.
export function ensureFontsInjected() {
  if (fontsReadyPromise) return fontsReadyPromise;

  const base = `${API_BASE}/editor-fonts`;
  const rules = FONT_FAMILIES.flatMap((name) => {
    const slug = name.replace(/\s+/g, "");
    return [
      `@font-face { font-family:'${name}'; font-weight:400; font-display:swap; src:url('${base}/${slug}-Regular.woff2') format('woff2'); }`,
      `@font-face { font-family:'${name}'; font-weight:700; font-display:swap; src:url('${base}/${slug}-Bold.woff2') format('woff2'); }`,
    ];
  });
  const style = document.createElement("style");
  style.id = "app-fonts";
  style.textContent = rules.join("\n");
  document.head.appendChild(style);

  const loads = FONT_FAMILIES.flatMap((name) => [
    document.fonts.load(`400 16px '${name}'`),
    document.fonts.load(`700 16px '${name}'`),
  ]);
  fontsReadyPromise = Promise.all(loads).catch(() => {});
  return fontsReadyPromise;
}
